<template>
  <div class="main-left-top">
    <div class="main-left-header" @click="toIndexPath">
      <span class="line"></span>
      极兔API简介
    </div>

    <div class="main-left-aside">
       <el-menu
       router
       ref="openApiMenu"
       active-text-color="#C31422"
      :default-active="activeIndex == '/apiDoc/index'?null:activeIndex"
      class="api-menu-vertical">
      <el-submenu v-for="(menuItem,menuIndex) in asideList" :index="`menu${menuIndex}`"  :key="menuIndex">
        <template slot="title">
          <span>{{menuItem.title}}</span>
        </template>
          <el-menu-item v-for="subItem in menuItem.subTitle"
          :key="subItem.path"
          :index="subItem.path">{{subItem.title}}</el-menu-item>
      </el-submenu>
    </el-menu>


      <!-- <div class="main-left-aside-item" v-for="(item,index) in asideList" :key="index">
        <div class="title">{{item.title}}</div>

        <div
          class="subTitle"
          v-for="(subItem,subIndex) in item.subTitle"
          :key="subIndex"
        >
          <span class="subTitle_click"
          :class="{active:subItem.path==$route.path}"
           @click.stop="subItem.path&&subItem.path!=$route.path&&$router.push(subItem.path)">{{subItem.title}}</span>
        </div>

      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex:this.$route.path,
      asideList: [
        {
          title: "基础信息",
          subTitle: [
            {
              title: "获取极兔省市区",
              path: "/apiDoc/basic",
            },
          ],
        },
        {
          title: "订单服务",
          subTitle: [
            {
              title: "创建订单",
              path: "/apiDoc/orderserve/create",
            },
            {
              title: "创建订单（带运单号）",
              path: "/apiDoc/orderserve/createWithWaybillNo",
            },
            {
              title: "查询订单",
              path: "/apiDoc/orderserve/query",
            },
            {
              title: "取消订单",
              path: "/apiDoc/orderserve/cancel",
            },
            {
              title: "订单状态回传",
              path: "/apiDoc/orderserve/statusFeedback",
            },
            {
              title: "散客寄件",
              path: "/apiDoc/orderserve/addLooseOrder",
            },
            {
              title: "一段单信息下发接口",
              path: "/apiDoc/orderserve/messageTransmission",
            },
            {
              title: "二段单映射关系回传",
              path: "/apiDoc/orderserve/shipmentWaybill",
            },
          ],
        },
        {
          title: "电子面单",
          subTitle: [
            {
              title: "电子面单账号检验",
              path: "/apiDoc/vip/query",
            },
            {
              title: "电子面单余额查询",
              path: "/apiDoc/vip/balance",
            },
            {
              title: "获取电子面单",
              path: "/apiDoc/vip/getwaybill",
            },
            {
              title: "面单打印",
              path: "/apiDoc/vip/printOrder",
            },
          ],
        },
        {
          title: "物流轨迹",
          subTitle: [
            {
              title: "物流轨迹查询",
              path: "/apiDoc/logistics/query",
            },{
              title: "物流轨迹订阅",
              path: "/apiDoc/logistics/subscribe",
            },
            {
              title: "物流轨迹回传",
              path: "/apiDoc/logistics/statusFeedback",
            },

          ],
        },
        {
          title: "临时车招采",
          subTitle: [
            {
              title: "投标或弃标接口",
              path: "/apiDoc/tempCarTender/tenderOfferPrice",
            },
            {
              title: "查询标的报价排名接口",
              path: "/apiDoc/tempCarTender/queryTenderSortNum",
            },
            {
              title: "招标信息发布回传接口",
              path: "/apiDoc/tempCarTender/tenderOfferReturn",
            },
            {
              title: "定标/废标/定标取消回传接口",
              path: "/apiDoc/tempCarTender/tenderOfferPriceReturn",
            },
            {
              title: "查询剩余报价次数接口",
              path: "/apiDoc/tempCarTender/queryTenderQuoteNum",
            }
          ]
        },
        {
          title: "其他服务",
          subTitle: [
            {
              title: "短信代发查询",
              path: "/apiDoc/other/smsGetMobile",
            },
            {
              title: "短信发送",
              path: "/apiDoc/other/messageSend",
            },
            {
              title: "短信状态回传",
              path: "/apiDoc/other/sMSstatusReturn",
            },
            // {
            //   title: "超区查询",
            //   path: "/apiDoc/other/cover",
            // },
            {
              title: "超区查询（新）",
              path: "/apiDoc/other/covernew",
            },
            {
              title: "收派范围查询",
              path: "/apiDoc/other/pca",
            },
            {
              title: "网点信息及三段码查询",
              path: "/apiDoc/other/getInfo",
            },
            {
              title:"结算账单回传",
              path: "/apiDoc/other/settlementReturn",
            },
            {
              title:"实名制信息上传",
              path: "/apiDoc/other/realNameSaveInfo",
            },
            {
              title:"运费计算",
              path: "/apiDoc/other/freight",
            },
            {
              title:"三段码查询(新)",
              path: "/apiDoc/other/threeSegmentCode",
            },
            {
              title:"申报状态查询",
              path: "/apiDoc/other/declarationStatusQuery",
            },
            {
              title:"拦截下发",
              path: "/apiDoc/other/intercept",
            },
            {
              title:"拦截下发回传",
              path: "/apiDoc/other/interceptFeedback",
            }
          ],
        },
      ],

    };
  },
  methods:{
    toIndexPath(){
      if(this.$route.path != '/apiDoc/index'){
          this.$router.push('/apiDoc/index');
          this.$refs.openApiMenu.activeIndex = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.api-menu-vertical{
  border-right: none;
  //padding-bottom: 100px;
  ::v-deep .el-submenu__title{
    font-weight: 600;
  }
  ::v-deep .el-menu-item.is-active{
    font-weight: 600;
  }
}
.main-left-top{
    display: flex;
    flex-direction: column;
    height: 100%;
}
.main-left-header {
  position: relative;
  width: 100%;
  border-bottom: 1px solid $table-border-color;
  color: #2b2d42;
  font-size: 26px;
  font-weight: 900;
  line-height: 26px;
  padding: 22px 0 22px 20px;
  box-sizing: border-box;
  cursor: pointer;
  background: #fff;
  .line {
    width: 4px;
    height: 28px;
    background: $theme-color;
    border-radius: 2px;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 22px;
  }
}

.main-left-aside {
  box-sizing: border-box;
  flex: 1;
  overflow: auto;
  max-height: 700px;
  .main-left-aside-item {
    .title {
      font-size: 14px;
      color: #2b2d42;
      box-sizing: border-box;
      padding: 10px 20px;
      line-height: 14px;
    }
    .subTitle {
      font-size: 14px;
      font-weight: 400;
      color: #61666d;
      line-height: 50px;
      text-align: center;
      .subTitle_click {
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
      }
    }
  }
  .active {
    color: $theme-color;
  }
}
</style>
